import { listen, qs, qsa } from '@fluorescent/dom';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase.js';

gsap.registerPlugin(CustomEase);

export default items => {
  const events = [];

  const opacityEase = gsap.parseEase('0.40,0.00,0.00,1.00');
  const chipEaseIn = gsap.parseEase('0.40,0.00,0.10,1.00');
  const chipEaseOut = gsap.parseEase('0.30,0.00,0.00,1.00');

  items.forEach(item => {
    const imageOne = qs('.product-item__image--one', item);
    const imageTwo = qs('.product-item__image--two', item);
    const optionsElements = qsa('.product-item-options__list', item);

    events.push(
      listen(item, 'mouseenter', () => {
        enterItemAnimation(imageOne, imageTwo, optionsElements);
      })
    );
    events.push(
      listen(item, 'mouseleave', () => {
        leaveItemAnimation(imageOne, imageTwo, optionsElements);
      })
    );
  });

  function enterItemAnimation(imageOne, imageTwo, optionsElements) {
    if (imageTwo) {
      gsap.killTweensOf(imageTwo);
      gsap.killTweensOf(imageOne);
      gsap.set(imageTwo, { zIndex: 2 });
      gsap.set(imageOne, { zIndex: 1 });
      gsap.fromTo(
        imageTwo,
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, ease: opacityEase, duration: 0.66 }
      );
      gsap.to(imageOne, { opacity: 0, delay: 0.66 });
    }

    if (optionsElements) {
      optionsElements.forEach((optionElement, i) => {
        gsap.killTweensOf(optionElement);
        gsap.fromTo(
          optionElement,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            ease: chipEaseIn,
            duration: 0.66,
            delay: Number(i) * 0.1,
          }
        );
      });
    }
  }

  function leaveItemAnimation(imageOne, imageTwo, optionsElements) {
    if (imageTwo) {
      gsap.killTweensOf(imageTwo);
      gsap.killTweensOf(imageOne);
      gsap.set(imageOne, { zIndex: 2, opacity: 1 });
      gsap.set(imageTwo, { zIndex: 1, opacity: 0 });
    }

    if (optionsElements) {
      optionsElements.forEach(optionElement => {
        gsap.killTweensOf(optionElement);
        gsap.fromTo(
          optionElement,
          { y: 0, opacity: 1 },
          { opacity: 0, duration: 0.33, ease: chipEaseOut }
        );
      });
    }
  }

  return {
    destroy() {
      events.forEach(unsubscribe => unsubscribe());
    },
  };
};
